const vocabulary_A1 = [
    {
      "id": 1,
      "question": "Etelämanner",
      "answer": "Antarctica",
      "ru": "Антарктида"
    },
    {
      "id": 2,
      "question": "Ilmansuunnat",
      "answer": "points of the compass",
      "ru": "Стороны света"
    },
    {
      "id": 3,
      "question": "Seteli",
      "answer": "bill, note",
      "ru": "Купюра"
    },
    {
      "id": 4,
      "question": "Kolikko",
      "answer": "coin",
      "ru": "Монета"
    },
    {
      "id": 5,
      "question": "Otsikko",
      "answer": "mail subject",
      "ru": "Тема письма"
    },
    {
      "id": 6,
      "question": "Vaan",
      "answer": "but",
      "ru": "Но"
    },
    {
      "id": 7,
      "question": "Toivottavasti",
      "answer": "hopefully",
      "ru": "Надеюсь"
    },
    {
      "id": 8,
      "question": "Hassu",
      "answer": "funny",
      "ru": "Смешной"
    },
    {
      "id": 9,
      "question": "Muuttaa",
      "answer": "to move",
      "ru": "Переехать"
    },
    {
      "id": 10,
      "question": "Viileä",
      "answer": "cool",
      "ru": "Прохладный"
    },
    {
      "id": 11,
      "question": "Helle",
      "answer": "heat",
      "ru": "Жара"
    },
    {
      "id": 12,
      "question": "Selkeä",
      "answer": "clear",
      "ru": "Ясный"
    },
    {
      "id": 13,
      "question": "Sumuinen",
      "answer": "misty/foggy",
      "ru": "Туманный"
    },
    {
      "id": 14,
      "question": "Räntä",
      "answer": "sleet",
      "ru": "Мокрый снег"
    },
    {
      "id": 15,
      "question": "Ukkonen",
      "answer": "thunder",
      "ru": "Гром"
    },
    {
      "id": 16,
      "question": "Vuorokausi",
      "answer": "day",
      "ru": "Сутки"
    },
    {
      "id": 17,
      "question": "Hoikka",
      "answer": "slim",
      "ru": "Стройный"
    },
    {
      "id": 18,
      "question": "Kihara",
      "answer": "curly",
      "ru": "Кудрявый"
    },
    {
      "id": 19,
      "question": "Ilmoittautua",
      "answer": "enroll",
      "ru": "Записаться"
    },
    {
      "id": 20,
      "question": "Tarkistaa",
      "answer": "check",
      "ru": "Проверить"
    },
    {
      "id": 21,
      "question": "tärkeä",
      "answer": "important",
      "ru": "Важный"
    },
    {
      "id": 22,
      "question": "Lomake",
      "answer": "form",
      "ru": "Бланк"
    },
    {
      "id": 23,
      "question": "Nätti",
      "answer": "pretty",
      "ru": "Симпатичный"
    },
    {
      "id": 24,
      "question": "kalju",
      "answer": "bold",
      "ru": "Лысый"
    },
    {
      "id": 25,
      "question": "viikset",
      "answer": "moustache",
      "ru": "Усы"
    },
    {
      "id": 26,
      "question": "tukeva",
      "answer": "sturdy",
      "ru": "Крепкий"
    },
    {
      "id": 27,
      "question": "suloinen",
      "answer": "sweet",
      "ru": "Милый"
    },
    {
      "id": 28,
      "question": "söpö",
      "answer": "cute",
      "ru": "Симпатичный"
    },
    {
      "id": 29,
      "question": "vanhemmat",
      "answer": "parents",
      "ru": "Родители"
    },
    {
      "id": 30,
      "question": "kihloissa",
      "answer": "engaged",
      "ru": "Помолвлен"
    },
    {
      "id": 31,
      "question": "eronnut",
      "answer": "divorced",
      "ru": "Разведён"
    },
    {
      "id": 32,
      "question": "töissä",
      "answer": "working",
      "ru": "На работе"
    },
    {
      "id": 33,
      "question": "työtön",
      "answer": "unemployed",
      "ru": "Безработный"
    },
    {
      "id": 34,
      "question": "eläkkeellä",
      "answer": "retired",
      "ru": "На пенсии"
    },
    {
      "id": 35,
      "question": "soida",
      "answer": "to call/ to ring",
      "ru": "Звонить"
    },
    {
      "id": 36,
      "question": "muroja",
      "answer": "cereal",
      "ru": "Хлопья"
    },
    {
      "id": 37,
      "question": "voileipä",
      "answer": "sandwich",
      "ru": "Бутерброд"
    },
    {
      "id": 38,
      "question": "lähteä",
      "answer": "to leave",
      "ru": "Уходить"
    },
    {
      "id": 39,
      "question": "tunti",
      "answer": "hour",
      "ru": "Час"
    },
    {
      "id": 40,
      "question": "tavaratalo",
      "answer": "department store",
      "ru": "Универмаг"
    },
    {
      "id": 41,
      "question": "tarvita",
      "answer": "to need",
      "ru": "Нуждаться"
    },
    {
      "id": 42,
      "question": "kenkä",
      "answer": "shoe",
      "ru": "Обувь"
    },
    {
      "id": 43,
      "question": "osasto",
      "answer": "deparment",
      "ru": "Отдел"
    },
    {
      "id": 44,
      "question": "siellä",
      "answer": "there",
      "ru": "Там"
    },
    {
      "id": 45,
      "question": "sovittaa",
      "answer": "to try on",
      "ru": "Примерить"
    },
    {
      "id": 46,
      "question": "no",
      "answer": "well",
      "ru": "Ну"
    },
    {
      "id": 47,
      "question": "ihan",
      "answer": "quite",
      "ru": "Совсем"
    },
    {
      "id": 48,
      "question": "tyhmä",
      "answer": "stupid",
      "ru": "Глупый"
    },
    {
      "id": 49,
      "question": "vai niin",
      "answer": "I see",
      "ru": "Вот как"
    },
    {
      "id": 50,
      "question": "ihana",
      "answer": "lovely",
      "ru": "Чудесный"
    },
    {
      "id": 51,
      "question": "koko",
      "answer": "size",
      "ru": "Размер"
    },
    {
      "id": 52,
      "question": "liian",
      "answer": "too",
      "ru": "Слишком"
    },
    {
      "id": 53,
      "question": "varasto",
      "answer": "stock",
      "ru": "Склад"
    },
    {
      "id": 54,
      "question": "nousta",
      "answer": "to get up",
      "ru": "Вставать"
    },
    {
      "id": 55,
      "question": "polttaa tupakkaa",
      "answer": "smoke",
      "ru": "Курить"
    },
    {
      "id": 56,
      "question": "pestä",
      "answer": "to wash",
      "ru": "Мыть"
    },
    {
      "id": 57,
      "question": "siivota",
      "answer": "to clean",
      "ru": "Убирать"
    },
    {
      "id": 58,
      "question": "juosta",
      "answer": "to run",
      "ru": "Бежать"
    },
    {
      "id": 59,
      "question": "lentää",
      "answer": "to fly",
      "ru": "Летать"
    },
    {
      "id": 60,
      "question": "pyöräillä",
      "answer": "to cycle",
      "ru": "Ездить на велосипеде"
    },
    {
      "id": 61,
      "question": "vartti",
      "answer": "quarter- - used with time",
      "ru": "Четверть"
    },
    {
      "id": 62,
      "question": "yli",
      "answer": "past",
      "ru": "Мимо"
    },
    {
      "id": 63,
      "question": "vaille",
      "answer": "to - used with time",
      "ru": "Без"
    },
    {
      "id": 64,
      "question": "naisten osasto",
      "answer": "women's department",
      "ru": "Женский отдел"
    },
    {
      "id": 65,
      "question": "miesten osasto",
      "answer": "men's department",
      "ru": "Мужской отдел"
    },
    {
      "id": 66,
      "question": "sopiva",
      "answer": "fitting",
      "ru": "Подходящий"
    },
    {
      "id": 67,
      "question": "korkea",
      "answer": "high",
      "ru": "Высокий"
    },
    {
      "id": 68,
      "question": "harmaa",
      "answer": "grey",
      "ru": "Серый"
    },
    {
      "id": 69,
      "question": "vaatekaappi",
      "answer": "wardrobe",
      "ru": "Шкаф для одежды"
    },
    {
      "id": 70,
      "question": "vaaleanpunainen",
      "answer": "pink",
      "ru": "Розовый"
    },
    {
      "id": 71,
      "question": "lelulaatikko",
      "answer": "play basket",
      "ru": "Ящик для игрушек"
    },
    {
      "id": 72,
      "question": "lelu",
      "answer": "toy",
      "ru": "Игрушка"
    },
    {
      "id": 73,
      "question": "lattia",
      "answer": "floor",
      "ru": "Пол"
    },
    {
      "id": 74,
      "question": "leveä",
      "answer": "wide",
      "ru": "Широкий"
    },
    {
      "id": 75,
      "question": "matala",
      "answer": "low",
      "ru": "Низкий"
    },
    {
      "id": 76,
      "question": "seinä",
      "answer": "wall",
      "ru": "Стена"
    },
    {
      "id": 77,
      "question": "viihtyisä",
      "answer": "cozy",
      "ru": "Уютный"
    },
    {
      "id": 78,
      "question": "nojatuoli",
      "answer": "arm chair",
      "ru": "Кресло"
    },
    {
      "id": 79,
      "question": "kirjahylly",
      "answer": "bookshelf",
      "ru": "Книжная полка"
    },
    {
      "id": 80,
      "question": "piha",
      "answer": "garden",
      "ru": "Двор"
    },
    {
      "id": 81,
      "question": "nostaa",
      "answer": "to lift",
      "ru": "Поднимать"
    },
    {
      "id": 82,
      "question": "kantaa",
      "answer": "to carry",
      "ru": "Нести"
    },
    {
      "id": 83,
      "question": "tapahtua",
      "answer": "to happen",
      "ru": "Происходить"
    },
    {
      "id": 84,
      "question": "viedä",
      "answer": "to take",
      "ru": "Отвести"
    },
    {
      "id": 85,
      "question": "ovi",
      "answer": "door",
      "ru": "Дверь"
    },
    {
      "id": 86,
      "question": "kellari",
      "answer": "cellar",
      "ru": "Подвал"
    },
    {
      "id": 87,
      "question": "ylös",
      "answer": "up",
      "ru": "Вверх"
    },
    {
      "id": 88,
      "question": "huoltomies",
      "answer": "maintenance man",
      "ru": "Техник"
    },
    {
      "id": 89,
      "question": "huoltoyhtiö",
      "answer": "maintenance company",
      "ru": "Обслуживающая компания"
    },
    {
      "id": 90,
      "question": "asukas",
      "answer": "resident",
      "ru": "Житель"
    },
    {
      "id": 91,
      "question": "vesihana",
      "answer": "tap",
      "ru": "Кран"
    },
    {
      "id": 92,
      "question": "rikki",
      "answer": "broken",
      "ru": "Сломан"
    },
    {
      "id": 93,
      "question": "vika",
      "answer": "fault",
      "ru": "Неисправность"
    },
    {
      "id": 94,
      "question": "kunnolla",
      "answer": "properly",
      "ru": "Как следует"
    },
    {
      "id": 95,
      "question": "vuotaa",
      "answer": "to leak",
      "ru": "Течь"
    },
    {
      "id": 96,
      "question": "selvä juttu",
      "answer": "I see",
      "ru": "Понятно"
    },
    {
      "id": 97,
      "question": "sopia",
      "answer": "to suit",
      "ru": "Подходить"
    },
    {
      "id": 98,
      "question": "hieno",
      "answer": "great",
      "ru": "Отличный"
    },
    {
      "id": 99,
      "question": "rappu",
      "answer": "stairway",
      "ru": "Подъезд"
    },
    {
      "id": 100,
      "question": "jo",
      "answer": "already",
      "ru": "Уже"
    },
    {
      "id": 101,
      "question": "alas",
      "answer": "down",
      "ru": "Вниз"
    },
    {
      "id": 102,
      "question": "kapea",
      "answer": "narrow",
      "ru": "Узкий"
    },
    {
      "id": 103,
      "question": "kova",
      "answer": "hard",
      "ru": "Твёрдый"
    },
    {
      "id": 104,
      "question": "kodikas",
      "answer": "homely",
      "ru": "Домашний"
    },
    {
      "id": 105,
      "question": "siisty",
      "answer": "tidy",
      "ru": "Аккуратный"
    },
    {
      "id": 106,
      "question": "sotkuinen",
      "answer": "messy",
      "ru": "Беспорядочный"
    },
    {
      "id": 107,
      "question": "vessa",
      "answer": "toilet",
      "ru": "Туалет"
    },
    {
      "id": 108,
      "question": "eteinen",
      "answer": "hall",
      "ru": "Прихожая"
    },
    {
      "id": 109,
      "question": "vaatehuone",
      "answer": "walk in closet",
      "ru": "Гардеробная"
    },
    {
      "id": 110,
      "question": "lattia",
      "answer": "floor",
      "ru": "Пол"
    },
    {
      "id": 111,
      "question": "alakerta",
      "answer": "downstairs",
      "ru": "Нижний этаж"
    },
    {
      "id": 112,
      "question": "yläkerta",
      "answer": "upstairs",
      "ru": "Верхний этаж"
    },
    {
      "id": 113,
      "question": "autotalli",
      "answer": "garage",
      "ru": "Гараж"
    },
    {
      "id": 114,
      "question": "rappukäytävä",
      "answer": "stairway",
      "ru": "Лестничная клетка"
    },
    {
      "id": 115,
      "question": "huonekalut",
      "answer": "furniture",
      "ru": "Мебель"
    },
    {
      "id": 116,
      "question": "verhot",
      "answer": "curtain",
      "ru": "Шторы"
    },
    {
      "id": 117,
      "question": "taulu",
      "answer": "painting",
      "ru": "Картина"
    },
    {
      "id": 118,
      "question": "peili",
      "answer": "mirror",
      "ru": "Зеркало"
    },
    {
      "id": 119,
      "question": "kylpyamme",
      "answer": "bathtub",
      "ru": "Ванна"
    },
    {
      "id": 120,
      "question": "pesuallas",
      "answer": "sink",
      "ru": "Умывальник"
    },
    {
      "id": 121,
      "question": "hella + uuni",
      "answer": "stove + oven",
      "ru": "Плита + духовка"
    },
    {
      "id": 122,
      "question": "vedenkeitin",
      "answer": "electric kettle",
      "ru": "Электрический чайник"
    },
    {
      "id": 123,
      "question": "leivänpaahdin",
      "answer": "toaster",
      "ru": "Тостер"
    },
    {
      "id": 124,
      "question": "kaukosäädin",
      "answer": "remote controller",
      "ru": "Пульт дистанционного управления"
    },
    {
      "id": 125,
      "question": "Ahvenanmaa",
      "answer": "Aland - island in finland",
      "ru": "Аландские острова"
    },
    {
      "id": 126,
      "question": "laiva",
      "answer": "ship",
      "ru": "Корабль"
    },
    {
      "id": 127,
      "question": "herkullinen",
      "answer": "delicious",
      "ru": "Вкусный"
    },
    {
      "id": 128,
      "question": "kuohuviini",
      "answer": "sparkling vine",
      "ru": "Игристое вино"
    },
    {
      "id": 129,
      "question": "katsella",
      "answer": "to look",
      "ru": "Смотреть"
    },
    {
      "id": 130,
      "question": "tanssilattia",
      "answer": "dance floor",
      "ru": "Танцпол"
    },
    {
      "id": 131,
      "question": "saapua",
      "answer": "to arrive",
      "ru": "Прибывать"
    },
    {
      "id": 132,
      "question": "noin",
      "answer": "approximately",
      "ru": "Примерно"
    },
    {
      "id": 133,
      "question": "vene",
      "answer": "boat",
      "ru": "Лодка"
    },
    {
      "id": 134,
      "question": "tai",
      "answer": "or",
      "ru": "Или"
    },
    {
      "id": 135,
      "question": "lossi",
      "answer": "ferry",
      "ru": "Паром"
    },
    {
      "id": 136,
      "question": "linna",
      "answer": "castle",
      "ru": "Замок"
    },
    {
      "id": 137,
      "question": "museo",
      "answer": "museum",
      "ru": "Музей"
    },
    {
      "id": 138,
      "question": "teltta",
      "answer": "tent",
      "ru": "Палатка"
    },
    {
      "id": 139,
      "question": "itse",
      "answer": "yourself",
      "ru": "Сам"
    },
    {
      "id": 140,
      "question": "palata",
      "answer": "return",
      "ru": "Возвращаться"
    },
    {
      "id": 141,
      "question": "kamala",
      "answer": "horrible",
      "ru": "Ужасный"
    },
    {
      "id": 142,
      "question": "niin",
      "answer": "so",
      "ru": "Так"
    },
    {
      "id": 143,
      "question": "märkä",
      "answer": "wet",
      "ru": "Мокрый"
    },
    {
      "id": 144,
      "question": "toinen",
      "answer": "another, second",
      "ru": "Другой, второй"
    },
    {
      "id": 145,
      "question": "varmasti",
      "answer": "surely",
      "ru": "Точно"
    },
    {
      "id": 146,
      "question": "oikein",
      "answer": "very, true",
      "ru": "Очень, правда"
    },
    {
      "id": 147,
      "question": "ihana",
      "answer": "lovely",
      "ru": "Чудесный"
    },
    {
      "id": 148,
      "question": "vastanotto",
      "answer": "reception",
      "ru": "Ресепшн"
    },
    {
      "id": 149,
      "question": "hotellivirkailija",
      "answer": "hotel receptionist",
      "ru": "Администратор отеля"
    },
    {
      "id": 150,
      "question": "henki",
      "answer": "person",
      "ru": "Человек"
    },
    {
      "id": 151,
      "question": "viipyä",
      "answer": "to stay",
      "ru": "Задержаться"
    },
    {
      "id": 152,
      "question": "täytyä",
      "answer": "must",
      "ru": "Должен"
    },
    {
      "id": 153,
      "question": "luovuttaa",
      "answer": "to vacate, to give in",
      "ru": "Освободить"
    },
    {
      "id": 154,
      "question": "rekka auto",
      "answer": "lorry , truck",
      "ru": "Грузовик"
    },
    {
      "id": 155,
      "question": "moottoripyörä",
      "answer": "motorcycle",
      "ru": "Мотоцикл"
    },
    {
      "id": 156,
      "question": "pakettiauto",
      "answer": "van",
      "ru": "Фургон"
    },
    {
      "id": 157,
      "question": "lähteä",
      "answer": "to leave",
      "ru": "Уходить"
    },
    {
      "id": 158,
      "question": "kävellen",
      "answer": "by foot",
      "ru": "Пешком"
    },
    {
      "id": 159,
      "question": "lisävuode",
      "answer": "extra bed",
      "ru": "Дополнительная кровать"
    },
    {
      "id": 160,
      "question": "yöpyä",
      "answer": "to stay overnight",
      "ru": "Ночевать"
    },
    {
      "id": 161,
      "question": "kuulua hintaan",
      "answer": "included in the price",
      "ru": "Входит в цену"
    },
    {
      "id": 162,
      "question": "louvuttaa huone",
      "answer": "vacate the room",
      "ru": "Освободить комнату"
    },
    {
      "id": 163,
      "question": "onni",
      "answer": "luck",
      "ru": "Удача"
    },
    {
      "id": 164,
      "question": "tupaantuliaiset",
      "answer": "house warming party",
      "ru": "Новоселье"
    },
    {
      "id": 165,
      "question": "kylään",
      "answer": "to come over",
      "ru": "В гости"
    },
    {
      "id": 166,
      "question": "pastasalaatti",
      "answer": "pasta salad",
      "ru": "Паста-салат"
    },
    {
      "id": 167,
      "question": "lihapulla",
      "answer": "meatball",
      "ru": "Тефтель"
    },
    {
      "id": 168,
      "question": "leipoa",
      "answer": "to bake",
      "ru": "Печь"
    },
    {
      "id": 169,
      "question": "näyttää",
      "answer": "to show",
      "ru": "Показывать"
    },
    {
      "id": 170,
      "question": "heille",
      "answer": "them",
      "ru": "Им"
    },
    {
      "id": 171,
      "question": "heistä",
      "answer": "they",
      "ru": "О них"
    },
    {
      "id": 172,
      "question": "kodikas",
      "answer": "cozy",
      "ru": "Уютный"
    },
    {
      "id": 173,
      "question": "tuoda",
      "answer": "to bring",
      "ru": "Приносить"
    },
    {
      "id": 174,
      "question": "ruisleipä",
      "answer": "rye bread",
      "ru": "Ржаной хлеб"
    },
    {
      "id": 175,
      "question": "vitsi",
      "answer": "joke",
      "ru": "Шутка"
    },
    {
      "id": 176,
      "question": "vessaharja",
      "answer": "toilet brush",
      "ru": "Ёршик"
    },
    {
      "id": 177,
      "question": "pitää",
      "answer": "to like",
      "ru": "Нравиться"
    },
    {
      "id": 178,
      "question": "makea",
      "answer": "sweet",
      "ru": "Сладкий"
    },
    {
      "id": 179,
      "question": "hapan",
      "answer": "sour",
      "ru": "Кислый"
    },
    {
      "id": 180,
      "question": "jälkeen",
      "answer": "after",
      "ru": "После"
    },
    {
      "id": 181,
      "question": "kaveri",
      "answer": "friend",
      "ru": "Друг"
    },
    {
      "id": 182,
      "question": "jutella",
      "answer": "to talk",
      "ru": "Разговаривать"
    },
    {
      "id": 183,
      "question": "kuunnella",
      "answer": "to listen",
      "ru": "Слушать"
    },
    {
      "id": 184,
      "question": "musiikki",
      "answer": "music",
      "ru": "Музыка"
    },
    {
      "id": 185,
      "question": "oli",
      "answer": "was",
      "ru": "Был"
    },
    {
      "id": 186,
      "question": "lautasliina",
      "answer": "napkin",
      "ru": "Салфетка"
    },
    {
      "id": 187,
      "question": "kuppi",
      "answer": "cup",
      "ru": "Чашка"
    },
    {
      "id": 188,
      "question": "muki",
      "answer": "mug",
      "ru": "Кружка"
    },
    {
      "id": 189,
      "question": "kattila",
      "answer": "pot",
      "ru": "Кастрюля"
    },
    {
      "id": 190,
      "question": "tarjotin",
      "answer": "tray",
      "ru": "Поднос"
    },
    {
      "id": 191,
      "question": "kulho",
      "answer": "bowl",
      "ru": "Миска"
    },
    {
      "id": 192,
      "question": "piimä",
      "answer": "sour milk",
      "ru": "Кефир"
    },
    {
      "id": 193,
      "question": "sämpylä",
      "answer": "roll",
      "ru": "Булочка"
    },
    {
      "id": 194,
      "question": "makkara",
      "answer": "sausage",
      "ru": "Колбаса"
    },
    {
      "id": 195,
      "question": "murot",
      "answer": "cereal",
      "ru": "Мюсли"
    },
    {
      "id": 196,
      "question": "hillo",
      "answer": "jam",
      "ru": "Варенье"
    },
    {
      "id": 197,
      "question": "paha",
      "answer": "bad",
      "ru": "Плохой"
    },
    {
      "id": 198,
      "question": "kypsä",
      "answer": "ripe",
      "ru": "Спелый"
    },
    {
      "id": 199,
      "question": "raaka",
      "answer": "raw",
      "ru": "Сырой"
    },
    {
      "id": 200,
      "question": "tuore",
      "answer": "fresh",
      "ru": "Свежий"
    },
    {
      "id": 201,
      "question": "rasvainen",
      "answer": "fatty",
      "ru": "Жирный"
    },
    {
      "id": 202,
      "question": "mieto",
      "answer": "mild",
      "ru": "Мягкий"
    },
    {
      "id": 203,
      "question": "terveellinen",
      "answer": "healthy",
      "ru": "Здоровый"
    },
    {
      "id": 204,
      "question": "epäterveellinen",
      "answer": "unhealthy",
      "ru": "Нездоровый"
    },
    {
      "id": 205,
      "question": "edullinen",
      "answer": "affordable",
      "ru": "Доступный"
    },
    {
      "id": 206,
      "question": "halpa",
      "answer": "cheap",
      "ru": "Дешёвый"
    },
    {
      "id": 207,
      "question": "toivotus",
      "answer": "wish",
      "ru": "Пожелание"
    },
    {
      "id": 208,
      "question": "ristiäiset",
      "answer": "christening",
      "ru": "Крестины"
    },
    {
      "id": 209,
      "question": "häät",
      "answer": "wedding",
      "ru": "Свадьба"
    },
    {
      "id": 210,
      "question": "hautajaiset",
      "answer": "funeral",
      "ru": "Похороны"
    },
    {
      "id": 211,
      "question": "läksiäiset",
      "answer": "farewell party",
      "ru": "Проводы"
    },
    {
      "id": 212,
      "question": "syntymäpäiväsänkari",
      "answer": "birthday boy/girl",
      "ru": "Именинник"
    },
    {
      "id": 213,
      "question": "ajo ohjeet",
      "answer": "driving instructions",
      "ru": "Инструкции по вождению"
    },
    {
      "id": 214,
      "question": "kaukana",
      "answer": "far",
      "ru": "Далеко"
    },
    {
      "id": 215,
      "question": "liikennevalot",
      "answer": "traffic lights",
      "ru": "Светофор"
    },
    {
      "id": 216,
      "question": "liikenneympärä",
      "answer": "roundabout",
      "ru": "Кольцевое движение"
    },
    {
      "id": 217,
      "question": "lähellä",
      "answer": "close",
      "ru": "Близко"
    },
    {
      "id": 218,
      "question": "kansio",
      "answer": "folder",
      "ru": "Папка"
    },
    {
      "id": 219,
      "question": "kokous",
      "answer": "meeting",
      "ru": "Совещание"
    },
    {
      "id": 220,
      "question": "neuvottuluhuone",
      "answer": "conference room",
      "ru": "Переговорная комната"
    },
    {
      "id": 221,
      "question": "kannettava tietekone",
      "answer": "laptop computer",
      "ru": "Ноутбук"
    },
    {
      "id": 222,
      "question": "mukaan",
      "answer": "with",
      "ru": "С собой"
    },
    {
      "id": 223,
      "question": "tavata",
      "answer": "to meet",
      "ru": "Встречать"
    },
    {
      "id": 224,
      "question": "esitellä",
      "answer": "to present",
      "ru": "Представлять"
    },
    {
      "id": 225,
      "question": "tyytyväinen",
      "answer": "satisfied",
      "ru": "Довольный"
    },
    {
      "id": 226,
      "question": "kuluttua",
      "answer": "included in the price",
      "ru": "Спустя"
    },
    {
      "id": 227,
      "question": "neuvotella",
      "answer": "to negotiate",
      "ru": "Переговорить"
    },
    {
      "id": 228,
      "question": "aikataulu",
      "answer": "schedule",
      "ru": "Расписание"
    },
    {
      "id": 229,
      "question": "luvata",
      "answer": "to promise",
      "ru": "Обещать"
    },
    {
      "id": 230,
      "question": "palaveri",
      "answer": "meeting",
      "ru": "Совещание"
    },
    {
      "id": 231,
      "question": "ruokala",
      "answer": "canteen",
      "ru": "Столовая"
    },
    {
      "id": 232,
      "question": "ylityö",
      "answer": "over time",
      "ru": "Сверхурочная работа"
    },
    {
      "id": 233,
      "question": "hakea",
      "answer": "to get",
      "ru": "Получить"
    },
    {
      "id": 234,
      "question": "pomo",
      "answer": "boss",
      "ru": "Начальник"
    },
    {
      "id": 235,
      "question": "puhelu",
      "answer": "phone call",
      "ru": "Звонок"
    },
    {
      "id": 236,
      "question": "kertoa",
      "answer": "to tell",
      "ru": "Рассказать"
    },
    {
      "id": 237,
      "question": "tulostaa",
      "answer": "to print",
      "ru": "Распечатать"
    },
    {
      "id": 238,
      "question": "panna",
      "answer": "to put",
      "ru": "Положить"
    },
    {
      "id": 239,
      "question": "vastata",
      "answer": "to answer",
      "ru": "Отвечать"
    },
    {
      "id": 240,
      "question": "melkein",
      "answer": "almost",
      "ru": "Почти"
    },
    {
      "id": 241,
      "question": "jäävesi",
      "answer": "ice water",
      "ru": "Ледяная вода"
    },
    {
      "id": 242,
      "question": "kivennäisvesi",
      "answer": "mineral water",
      "ru": "Минеральная вода"
    },
    {
      "id": 243,
      "question": "maistua",
      "answer": "to sweet",
      "ru": "Иметь вкус"
    },
    {
      "id": 244,
      "question": "juttu",
      "answer": "thing",
      "ru": "Вещь"
    },
    {
      "id": 245,
      "question": "saman tien",
      "answer": "right away",
      "ru": "Сразу же"
    },
    {
      "id": 246,
      "question": "erikseen",
      "answer": "separately",
      "ru": "Отдельно"
    },
    {
      "id": 247,
      "question": "ydessä",
      "answer": "together",
      "ru": "Вместе"
    },
    {
      "id": 248,
      "question": "fima",
      "answer": "firm",
      "ru": "Фирма"
    },
    {
      "id": 249,
      "question": "yritys",
      "answer": "business, company",
      "ru": "Компания"
    },
    {
      "id": 250,
      "question": "neukkari",
      "answer": "conference room",
      "ru": "Переговорная"
    },
    {
      "id": 251,
      "question": "työaika",
      "answer": "working hours",
      "ru": "Рабочее время"
    },
    {
      "id": 252,
      "question": "työvuoro",
      "answer": "shift",
      "ru": "Смена"
    },
    {
      "id": 253,
      "question": "ylityö",
      "answer": "overtime",
      "ru": "Сверхурочные"
    },
    {
      "id": 254,
      "question": "printata",
      "answer": "to print",
      "ru": "Распечатать"
    },
    {
      "id": 255,
      "question": "printteri",
      "answer": "to print",
      "ru": "Принтер"
    },
    {
      "id": 256,
      "question": "faksi",
      "answer": "fax",
      "ru": "Факс"
    },
    {
      "id": 257,
      "question": "kännykkä",
      "answer": "mobile phone",
      "ru": "Мобильный телефон"
    },
    {
      "id": 258,
      "question": "työnantaja",
      "answer": "employer",
      "ru": "Работодатель"
    },
    {
      "id": 259,
      "question": "työntekijä",
      "answer": "employer",
      "ru": "Работник"
    },
    {
      "id": 260,
      "question": "sairaanhoitaja",
      "answer": "nurse",
      "ru": "Медсестра"
    },
    {
      "id": 261,
      "question": "myyjä",
      "answer": "salesperson",
      "ru": "Продавец"
    },
    {
      "id": 262,
      "question": "rekkakuski",
      "answer": "trucker",
      "ru": "Дальнобойщик"
    },
    {
      "id": 263,
      "question": "automekaanikko",
      "answer": "car mechanic",
      "ru": "Автомеханик"
    },
    {
      "id": 264,
      "question": "maanviljelijä",
      "answer": "farmer",
      "ru": "Фермер"
    },
    {
      "id": 265,
      "question": "kirjailija",
      "answer": "writer",
      "ru": "Писатель"
    },
    {
      "id": 266,
      "question": "näyttelija",
      "answer": "actor, actress",
      "ru": "Актёр"
    },
    {
      "id": 267,
      "question": "urheilija",
      "answer": "athelete",
      "ru": "Спортсмен"
    },
    {
      "id": 268,
      "question": "palomies",
      "answer": "fire fighter",
      "ru": "Пожарный"
    },
    {
      "id": 269,
      "question": "pappi",
      "answer": "priest",
      "ru": "Священник"
    },
    {
      "id": 270,
      "question": "yksityisyrittäjä",
      "answer": "sole trader",
      "ru": "Индивидуальный предприниматель"
    },
    {
      "id": 271,
      "question": "putkiasentaja",
      "answer": "plumber",
      "ru": "Сантехник"
    },
    {
      "id": 272,
      "question": "putkimies",
      "answer": "plumber",
      "ru": "Сантехник"
    },
    {
      "id": 273,
      "question": "sähköasentaja",
      "answer": "electrician",
      "ru": "Электрик"
    },
    {
      "id": 274,
      "question": "maalari",
      "answer": "painter",
      "ru": "Маляр"
    },
    {
      "id": 275,
      "question": "postinjakaja",
      "answer": "mailaman",
      "ru": "Почтальон"
    },
    {
      "id": 276,
      "question": "vahtimestari",
      "answer": "doorman",
      "ru": "Швейцар"
    },
    {
      "id": 277,
      "question": "vartija",
      "answer": "guard",
      "ru": "Охранник"
    },
    {
      "id": 278,
      "question": "kiinteistövälittäjä",
      "answer": "real estate agent",
      "ru": "Агент по недвижимости"
    },
    {
      "id": 279,
      "question": "toimitusjohtaja",
      "answer": "CEO",
      "ru": "Генеральный директор"
    },
    {
      "id": 280,
      "question": "henkilöstöpäälikkö",
      "answer": "personnel manager",
      "ru": "Начальник отдела кадров"
    },
    {
      "id": 281,
      "question": "assistentti",
      "answer": "assistant",
      "ru": "Ассистент"
    },
    {
      "id": 282,
      "question": "kirjanpitäjä",
      "answer": "accountant",
      "ru": "Бухгалтер"
    },
    {
      "id": 283,
      "question": "toimittaja",
      "answer": "journalist, reporter",
      "ru": "Журналист"
    },
    {
      "id": 284,
      "question": "valokuvaaja",
      "answer": "photographer",
      "ru": "Фотограф"
    },
    {
      "id": 285,
      "question": "siivoja",
      "answer": "cleaner",
      "ru": "Уборщик"
    },
    {
      "id": 286,
      "question": "kampaaja",
      "answer": "hairdresser",
      "ru": "Парикмахер"
    },
    {
      "id": 287,
      "question": "parturi",
      "answer": "barber",
      "ru": "Барбер"
    },
    {
      "id": 288,
      "question": "kosmetologi",
      "answer": "cosmetologist",
      "ru": "Косметолог"
    },
    {
      "id": 289,
      "question": "tarjoilija",
      "answer": "waiter",
      "ru": "Официант"
    },
    {
      "id": 290,
      "question": "keittiöapulainen",
      "answer": "kitchen help",
      "ru": "Помощник повара"
    },
    {
      "id": 291,
      "question": "lastentarhanopettaja",
      "answer": "kindergarten teacher",
      "ru": "Воспитатель детского сада"
    },
    {
      "id": 292,
      "question": "lastenhoitaja",
      "answer": "nanny",
      "ru": "Няня"
    },
    {
      "id": 293,
      "question": "ruokalista",
      "answer": "menu",
      "ru": "Меню"
    },
    {
      "id": 294,
      "question": "alkuruoka",
      "answer": "starter",
      "ru": "Закуска"
    },
    {
      "id": 295,
      "question": "pääruoka",
      "answer": "main course",
      "ru": "Основное блюдо"
    },
    {
      "id": 296,
      "question": "jälkiruoka",
      "answer": "dessert",
      "ru": "Десерт"
    },
    {
      "id": 297,
      "question": "lasku",
      "answer": "bill, check",
      "ru": "Счёт"
    }
  ];

export default vocabulary_A1;
